import { PieTooltipProps, ResponsivePie } from '@nivo/pie'
import { useStyles } from './PieChartComponent.styles'
import { FC } from 'react'

export type PieDataProperty = {
  id: string
  label: string
  value: number
}

export type PieProps = {
  data: PieDataProperty[]
  height?: string
  width?: string
  colors: string[]
  tooltipContent?: FC<
    PieTooltipProps<{
      id: string
      label: string
      value: number
    }>
  >
}

export const PieChartComponent = ({
  data,
  height,
  width,
  tooltipContent,
  colors,
}: PieProps) => {
  const { classes } = useStyles({ height, width })

  return (
    <div className={classes.pieWrapper} data-testid={'pie-chart'}>
      <ResponsivePie
        data={data}
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        innerRadius={0}
        padAngle={0}
        cornerRadius={0}
        activeOuterRadiusOffset={8}
        borderWidth={1}
        colors={colors}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 0.2]],
        }}
        enableArcLinkLabels={false}
        enableArcLabels={false}
        tooltip={tooltipContent}
      />
    </div>
  )
}
